import React, { useState, useRef } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';




const ContactSection = styled.section`
  padding: 80px 0;
  background-color: white;
`;

const SectionTitle = styled.div`
  text-align: center;
  margin-bottom: 50px;
  
  h2 {
    font-size: 2.5rem;
    color: var(--primary-color);
    position: relative;
    display: inline-block;
    padding-bottom: 15px;
    
    @media (max-width: 768px) {
      font-size: 2rem;
    }
    
    &::after {
      content: '';
      position: absolute;
      left: 50%;
      bottom: 0;
      transform: translateX(-50%);
      width: 80px;
      height: 4px;
      background-color: var(--accent-color);
    }
  }
`;

const MethodsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 30px;
  margin-bottom: 50px;
  
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    padding: 0 15px;
  }
`;

const MethodCard = styled.div`
  background-color: white;
  padding: 30px;
  border-radius: 10px;
  box-shadow: var(--shadow);
  text-align: center;
  transition: transform 0.3s;
  
  &:hover {
    transform: translateY(-10px);
  }
`;

const MethodIcon = styled.div`
  width: 80px;
  height: 80px;
  background-color: var(--primary-color);
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 20px;
  font-size: 40px;
`;

const Button = styled.a`
  display: inline-block;
  background-color: var(--accent-color);
  color: var(--dark-color);
  padding: 12px 30px;
  border: none;
  border-radius: 5px;
  font-weight: bold;
  text-decoration: none;
  cursor: pointer;
  transition: all 0.3s;
  margin-top: 20px;
  
  &:hover {
    background-color: #e0a800;
    transform: translateY(-3px);
  }
  
  @media (max-width: 768px) {
    padding: 12px 20px;
    font-size: 0.9rem;
    display: block;
    width: 100%;
    text-align: center;
  }
`;

const ContactForm = styled.form`
  max-width: 700px;
  margin: 0 auto;
  padding: 30px;
  background-color: var(--light-color);
  border-radius: 10px;
  box-shadow: var(--shadow);
  
  @media (max-width: 768px) {
    padding: 20px;
    margin: 0 15px;
  }
`;

const FormGroup = styled.div`
  margin-bottom: 20px;
  
  label {
    display: block;
    margin-bottom: 8px;
    font-weight: 500;
  }
  
  input, textarea, select {
    width: 100%;
    padding: 12px;
    border: 1px solid #ddd;
    border-radius: 5px;
    font-size: 16px;
    
    @media (max-width: 768px) {
      padding: 10px;
      font-size: 15px;
    }
  }
  
  textarea {
    height: 150px;
  }
`;

const CheckboxGroup = styled.div`
  display: flex;
  align-items: flex-start;
  
  input {
    width: auto;
    margin-right: 10px;
    margin-top: 5px;
  }
`;

const SubmitButton = styled.button`
  display: inline-block;
  background-color: var(--accent-color);
  color: var(--dark-color);
  padding: 12px 30px;
  border: none;
  border-radius: 5px;
  font-weight: bold;
  text-decoration: none;
  cursor: pointer;
  transition: all 0.3s;
  
  &:hover {
    background-color: #e0a800;
    transform: translateY(-3px);
  }
  
  &:disabled {
    background-color: #cccccc;
    cursor: not-allowed;
    transform: none;
  }
  
  @media (max-width: 768px) {
    width: 100%;
    font-size: 1rem;
  }
`;

const SuccessMessage = styled.div`
  background-color: #d4edda;
  color: #155724;
  padding: 20px;
  border-radius: 5px;
  margin: 0 15px 20px;
  text-align: center;
  box-shadow: var(--shadow);
`;

const ErrorMessage = styled.div`
  background-color: #f8d7da;
  color: #721c24;
  padding: 15px;
  border-radius: 5px;
  margin-bottom: 20px;
  text-align: center;
`;
const HiddenIframe = styled.iframe`
  display: none;
`;
function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: 'allgemein',
    customSubject: '',
    message: '',
    privacy: false
  });
  
  const [showCustomSubject, setShowCustomSubject] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitSuccess, setSubmitSuccess] = useState(false);
  const [submitError, setSubmitError] = useState('');
  
  // Reference to the form
  const formRef = useRef(null);
  
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    
    if (name === 'subject' && value === 'Sonstiges') {
      setShowCustomSubject(true);
    } else if (name === 'subject') {
      setShowCustomSubject(false);
    }
    
    setFormData({
      ...formData,
      [name]: type === 'checkbox' ? checked : value
    });
  };
  
  const handleSubmit = (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    
    // Create a FormData object from the form
    const form = formRef.current;
    const formDataObj = new FormData(form);
    
    // Submit the form using fetch
    fetch('https://formsubmit.co/ajax/info@guardiansmoves.de', {
      method: 'POST',
      body: formDataObj,
      headers: {
        'Accept': 'application/json'
      }
    })
    .then(response => response.json())
    .then(data => {
      setIsSubmitting(false);
      if (data.success) {
        setSubmitSuccess(true);
        // Reset form
        setFormData({
          name: '',
          email: '',
          phone: '',
          subject: 'allgemein',
          customSubject: '',
          message: '',
          privacy: false
        });
        setShowCustomSubject(false);
      } else {
        setSubmitError('Beim Senden des Formulars ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut.');
      }
    })
    .catch(error => {
      setIsSubmitting(false);
      setSubmitError('Beim Senden des Formulars ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut oder kontaktieren Sie uns direkt per Telefon oder E-Mail.');
      console.error('Error:', error);
    });
  };
  
  return (
    <ContactSection id="kontakt" className="contact">
      <div className="container">
        <SectionTitle className="section-title">
          <h2>Kontaktieren Sie uns</h2>
        </SectionTitle>
        
        <MethodsGrid className="methods-grid">
          <MethodCard className="method-card">
            <MethodIcon className="method-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="currentColor" viewBox="0 0 16 16">
                <path d="M3.654 1.328a.678.678 0 0 0-1.015-.063L1.605 2.3c-.483.484-.661 1.169-.45 1.77a17.568 17.568 0 0 0 4.168 6.608 17.569 17.569 0 0 0 6.608 4.168c.601.211 1.286.033 1.77-.45l1.034-1.034a.678.678 0 0 0-.063-1.015l-2.307-1.794a.678.678 0 0 0-.58-.122l-2.19.547a1.745 1.745 0 0 1-1.657-.459L5.482 8.062a1.745 1.745 0 0 1-.46-1.657l.548-2.19a.678.678 0 0 0-.122-.58L3.654 1.328z"/>
              </svg>
            </MethodIcon>
            <h3>Telefon</h3>
            <p>Rufen Sie uns direkt an:<br/>+49 155 6354 7378</p>
            <Button href="tel:+4915563547378" className="btn">anrufen</Button>
          </MethodCard>
          
          <MethodCard className="method-card">
            <MethodIcon className="method-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="currentColor" viewBox="0 0 16 16">
                <path d="M13.601 2.326A7.854 7.854 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.933 7.933 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.898 7.898 0 0 0 13.6 2.326zM7.994 14.521a6.573 6.573 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.557 6.557 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592zm3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.729.729 0 0 0-.529.247c-.182.198-.691.677-.691 1.654 0 .977.71 1.916.81 2.049.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232z"></path>
              </svg>
            </MethodIcon>
            <h3>WhatsApp</h3>
            <p>Schreiben sie uns eine nachricht per Whatsapp an</p>
            <Button href="https://wa.me/4915563547378?text=Anfrage%20bei%20GuardiansMoves" className="btn" target="_blank">Nachricht senden</Button>
          </MethodCard>
          
          <MethodCard className="method-card">
            <MethodIcon className="method-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="currentColor" viewBox="0 0 16 16">
                <path d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4Zm2-1a1 1 0 0 0-1 1v.217l7 4.2 7-4.2V4a1 1 0 0 0-1-1H2Zm13 2.383-4.708 2.825L15 11.105V5.383Zm-.034 6.876-5.64-3.471L8 9.583l-1.326-.795-5.64 3.47A1 1 0 0 0 2 13h12a1 1 0 0 0 .966-.741ZM1 11.105l4.708-2.897L1 5.383v5.722Z"></path>
              </svg>
            </MethodIcon>
            <h3>E-Mail</h3>
            <p>Schrieben sie uns per E-Mail an:<br/>info@guardiansmoves.de<br/></p>
            <Button href="mailto:info@guardiansmoves.de" className="btn">Mail senden</Button>
          </MethodCard>
        </MethodsGrid>
        
        {submitSuccess ? (
          <SuccessMessage>
            <h3>Vielen Dank für Ihre Nachricht!</h3>
            <p>Wir haben Ihre Anfrage erhalten und werden uns so schnell wie möglich bei Ihnen melden.</p>
            <Button as="button" onClick={() => setSubmitSuccess(false)} style={{ marginTop: '15px' }}>
              Neues Formular
            </Button>
          </SuccessMessage>
        ) : (
          <ContactForm 
            className="contact-form" 
            onSubmit={handleSubmit}
            ref={formRef}
          >
            {submitError && <ErrorMessage>{submitError}</ErrorMessage>}
            
            {/* FormSubmit Configuration */}
            <input type="hidden" name="_subject" value="Kontaktanfrage von der Website" />
            <input type="hidden" name="_captcha" value="false" />
            <input type="hidden" name="_template" value="table" />
            <input type="hidden" name="_honey" value="" /> {/* Spam honeypot */}
            
            <FormGroup className="form-group">
              <label htmlFor="name">Name *</label>
              <input 
                type="text" 
                id="name" 
                name="name" 
                value={formData.name}
                onChange={handleChange}
                required 
              />
            </FormGroup>
            
            <FormGroup className="form-group">
              <label htmlFor="email">E-Mail *</label>
              <input 
                type="email" 
                id="email" 
                name="email"
                value={formData.email}
                onChange={handleChange} 
                required 
              />
            </FormGroup>
            
            <FormGroup className="form-group">
              <label htmlFor="phone">Telefon</label>
              <input 
                type="tel" 
                id="phone" 
                name="phone"
                value={formData.phone}
                onChange={handleChange}
              />
            </FormGroup>
            
            <FormGroup className="form-group">
              <label htmlFor="subject">Betreff</label>
              <select 
                id="subject" 
                name="subject"
                value={formData.subject}
                onChange={handleChange}
              >
                <option value="allgemein">Allgemeine Anfrage</option>
                <option value="personenbefoerderung">Taxi&amp;Mietwagenservice</option>
                <option value="sicherheit">Sicherheit</option>
                <option value="reinigung">Reinigung</option>
                <option value="bewerbung">Initiativbewerbung</option>
                <option value="Sonstiges">Sonstiges</option>
              </select>
            </FormGroup>
            
            {showCustomSubject && (
              <FormGroup className="form-group" id="customSubjectContainer">
                <label htmlFor="customSubject">Bitte Betreff angeben</label>
                <input 
                  type="text" 
                  id="customSubject" 
                  name="customSubject"
                  value={formData.customSubject}
                  onChange={handleChange}
                />
              </FormGroup>
            )}
            
            <FormGroup className="form-group">
              <label htmlFor="message">Nachricht *</label>
              <textarea 
                id="message" 
                name="message"
                value={formData.message}
                onChange={handleChange}
                required
              ></textarea>
            </FormGroup>
            
            <FormGroup className="form-group checkbox-group">
              <CheckboxGroup>
                <input 
                  type="checkbox" 
                  id="privacy" 
                  name="privacy"
                  checked={formData.privacy}
                  onChange={handleChange}
                  required
                />
                <label htmlFor="privacy">
                  Ich habe die <Link to="/datenschutz">Datenschutzerklärung</Link> gelesen und akzeptiere diese. *
                </label>
              </CheckboxGroup>
            </FormGroup>
            
            <SubmitButton 
              type="submit" 
              className="btn"
              disabled={isSubmitting}
            >
              {isSubmitting ? 'Wird gesendet...' : 'Absenden'}
            </SubmitButton>
          </ContactForm>
        )}
      </div>
    </ContactSection>
  );
}

export default Contact;